const listeners = new Set();

export const showFullPageLoader = (id) => {
   listeners.forEach(listener => listener({ type: 'SHOW', id }));
};

export const hideFullPageLoader = (id) => {
   listeners.forEach(listener => listener({ type: 'HIDE', id }));
};

export const subscribeToFullPageLoader = listener => {
   listeners.add(listener);
   return () => listeners.delete(listener);
};
